
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/onboarding",
      function () {
        return require("private-next-pages/candidate/onboarding/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/onboarding"])
      });
    }
  